{
  "aerialway": [
    "station"
  ],
  "aeroway": [
    "gate"
  ],
  "amenity": [
    "ticket_validator",
    "photo_booth",
    "bench",
    "atm",
    "car_rental",
    "piano",
    "bureau_de_change",
    "vending_machine",
    "arts_centre",
    "bank",
    "bar",
    "bbq",
    "bicycle_parking",
    "bicycle_rental",
    "biergarten",
    "bus_station",
    "cafe",
    "cinema",
    "clinic",
    "college",
    "community_centre",
    "courthouse",
    "dentist",
    "doctors",
    "embassy",
    "fast_food",
    "ferry_terminal",
    "fire_station",
    "food_court",
    "fuel",
    "grave_yard",
    "hospital",
    "ice_cream",
    "kindergarten",
    "library",
    "marketplace",
    "motorcycle_parking",
    "nightclub",
    "nursing_home",
    "parking",
    "pharmacy",
    "place_of_worship",
    "police",
    "post_box",
    "post_office",
    "prison",
    "pub",
    "public_building",
    "recycling",
    "restaurant",
    "school",
    "shelter",
    "swimming_pool",
    "taxi",
    "telephone",
    "theatre",
    "toilets",
    "townhall",
    "university",
    "veterinary",
    "waste_basket"
  ],
  "barrier": [
    "bollard",
    "border_control",
    "cycle_barrier",
    "gate",
    "lift_gate",
    "sally_port",
    "stile",
    "toll_booth"
  ],
  "craft": [
    "caterer",
    "shoemaker",
    "tailor",
    "brewery",
    "confectionery",
    "dressmaker",
    "electronics_repair"
  ],
  "door": [
    "yes",
    "no",
    "hinged",
    "sliding",
    "overhead"
  ],
  "emergency": [
    "defibrillator",
    "phone",
    "fire_extinguisher"
  ],
  "entrance": [
    "yes",
    "main",
    "staircase",
    "home",
    "service",
    "emergency",
    "exit",
    "shop",
    "building"
  ],
  "exhibit": [
    "artwork",
    "history"
  ],
  "highway": [
    "elevator"
  ],
  "landuse": [
    "basin",
    "brownfield",
    "cemetery",
    "reservoir",
    "winter_sports"
  ],
  "leisure": [
    "dog_park",
    "escape_game",
    "garden",
    "golf_course",
    "ice_rink",
    "hackerspace",
    "marina",
    "miniature_golf",
    "park",
    "pitch",
    "playground",
    "sports_centre",
    "stadium",
    "swimming_area",
    "swimming_pool",
    "water_park"
  ],
  "office": [
    "government"
  ],
  "railway": [
    "halt",
    "station",
    "subway_entrance",
    "train_station_entrance",
    "tram_stop"
  ],
  "shop": [
    "leather",
    "variety_store",
    "fashion_accessories",
    "houseware",
    "seafood",
    "pastry",
    "cheese",
    "kitchen",
    "ticket",
    "frame",
    "tea",
    "locksmith",
    "accessories",
    "alcohol",
    "antiques",
    "art",
    "bag",
    "bakery",
    "beauty",
    "bed",
    "beverages",
    "bicycle",
    "books",
    "boutique",
    "butcher",
    "camera",
    "car",
    "car_repair",
    "car_parts",
    "carpet",
    "charity",
    "chemist",
    "chocolate",
    "clothes",
    "coffee",
    "computer",
    "confectionery",
    "convenience",
    "copyshop",
    "cosmetics",
    "deli",
    "delicatessen",
    "department_store",
    "doityourself",
    "dry_cleaning",
    "electronics",
    "erotic",
    "fabric",
    "florist",
    "frozen_food",
    "furniture",
    "garden_centre",
    "general",
    "gift",
    "greengrocer",
    "hairdresser",
    "hardware",
    "hearing_aids",
    "hifi",
    "ice_cream",
    "interior_decoration",
    "jewelry",
    "kiosk",
    "lamps",
    "laundry",
    "mall",
    "massage",
    "mobile_phone",
    "motorcycle",
    "music",
    "musical_instrument",
    "newsagent",
    "optician",
    "outdoor",
    "perfume",
    "perfumery",
    "pet",
    "photo",
    "second_hand",
    "shoes",
    "sports",
    "stationery",
    "supermarket",
    "tailor",
    "tattoo",
    "ticket",
    "tobacco",
    "toys",
    "travel_agency",
    "video",
    "video_games",
    "watches",
    "weapons",
    "wholesale",
    "wine"
  ],
  "sport": [
    "american_football",
    "archery",
    "athletics",
    "australian_football",
    "badminton",
    "baseball",
    "basketball",
    "beachvolleyball",
    "billiards",
    "bmx",
    "boules",
    "bowls",
    "boxing",
    "canadian_football",
    "canoe",
    "chess",
    "climbing",
    "climbing_adventure",
    "cricket",
    "cricket_nets",
    "croquet",
    "curling",
    "cycling",
    "disc_golf",
    "diving",
    "dog_racing",
    "equestrian",
    "fatsal",
    "field_hockey",
    "free_flying",
    "gaelic_games",
    "golf",
    "gymnastics",
    "handball",
    "hockey",
    "horse_racing",
    "horseshoes",
    "ice_hockey",
    "ice_stock",
    "judo",
    "karting",
    "korfball",
    "long_jump",
    "model_aerodrome",
    "motocross",
    "motor",
    "multi",
    "netball",
    "orienteering",
    "paddle_tennis",
    "paintball",
    "paragliding",
    "pelota",
    "racquet",
    "rc_car",
    "rowing",
    "rugby",
    "rugby_league",
    "rugby_union",
    "running",
    "sailing",
    "scuba_diving",
    "shooting",
    "shooting_range",
    "skateboard",
    "skating",
    "skiing",
    "soccer",
    "surfing",
    "swimming",
    "table_soccer",
    "table_tennis",
    "team_handball",
    "tennis",
    "toboggan",
    "volleyball",
    "water_ski",
    "yoga"
  ],
  "tourism": [
    "alpine_hut",
    "aquarium",
    "artwork",
    "attraction",
    "bed_and_breakfast",
    "camp_site",
    "caravan_site",
    "chalet",
    "gallery",
    "guest_house",
    "hostel",
    "hotel",
    "information",
    "motel",
    "museum",
    "picnic_site",
    "theme_park",
    "viewpoint",
    "zoo"
  ]
}
